import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type HistoryRecord = {
  query: string;
  platform: string;
  timestamp: number;
};

export type SearchHistoryState = {
  history: HistoryRecord[];
  fetched: boolean;
};

const initialState: SearchHistoryState = {
  history: [],
  fetched: false,
};

export const searchHistorySlice = createSlice({
  name: "searchHistoryManager",
  initialState,
  reducers: {
    updateHistory: (state, action: PayloadAction<HistoryRecord[]>) => {
      state.history = action.payload;
      state.fetched = true;
    },
  },
});

export const { updateHistory } = searchHistorySlice.actions;
export default searchHistorySlice.reducer;
